import styled from 'styled-components';

const Switch = ({ className, label, state, setState }) => (
  <label className={className}>
    <span>{label}</span>
    <input
      className="checkbox-switch"
      type="checkbox"
      checked={state}
      onChange={(e) => setState(e.target.checked)}
    />
  </label>
);

export default styled(Switch)`
  align-items: center;
  display: inline-flex;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 2.4rem;

  &:hover {
    cursor: pointer;
  }

  span {
    color: var(--cta-blue);
    display: inline-block;
    margin-right: 1rem;
  }

  input {
    appearance: none;
    isolation: isolate;
    margin: 0;
    position: relative;

    &:hover {
      cursor: pointer;
    }

    &::before,
    &::after {
      border-radius: 100vw;
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    &::before {
      background-color: var(--white);
      border: 0.15rem solid var(--cta-blue);
      bottom: 0;
      height: 1.4rem;
      left: 0.3rem;
      transition: left 0.25s ease-in-out, border-color 0.25s ease-in-out;
      width: 1.4rem;
      z-index: 2;
    }

    &:checked::before {
      background-color: var(--white);
      border: 0.15rem solid var(--white);
      left: 2.3rem;
    }

    &::after {
      background-color: var(--white);
      border: 0.15rem solid var(--cta-blue);
      height: 2rem;
      transition: background-color 0.25s ease-in-out 0.25s;
      width: 4rem;
      z-index: 1;
    }

    &:checked::after {
      background-color: var(--cta-blue);
    }
  }
`;
